import {
  attachCustomer,
  PrivacyTerms,
  SsnByItalianCustomerDetails,
} from "./../../@types/DTO/ApiResponses";
import { SelectedVehicleDetails } from "./../../@types/Booking/SelectedVehicleDetails.d";
import { OptionInVehicle, Vehicle } from "./../../@types/DTO/Vehicles.d";
import { CreateNewBooking, UserLoginResponse } from "../../@types/DTO/Booking";
import {
  CustomerDetailsResponse,
  CustomerDetailsResponse_2,
  DocumentUploadResponse,
  InsuranceDetails,
  ItalianCustomerDetailsUsingSSNResponse,
} from "../../@types/DTO/ApiResponses";
import axios, { AxiosResponse } from "axios";
import { BookingDetails } from "./../../@types/Booking/bookingDetails.d";
import { DetailsFormValues } from "../../components/Layouts/WebCheckInForms/WebCheckInForms.props";
import { Location } from "../../@types/DTO/Locations";
import { PrivacyPolicy } from "../../@types/DTO/privacyPolicy";
import { StateResponse } from "../../@types/DTO/LocationRequests";
import { BookingSourceResponse } from "../../@types/DTO/BookingSource";
import {
  AllPaymentMethodsResponse,
  PaymentLinkResponse,
} from "../../@types/DTO/AllPaymentMethods";
import { ReservationSuccessfullResponse } from "../../@types/DTO/ReservationDetails";
import { AppSettingResponse } from "../../@types/DTO/AppSetting";
import { companyDetails } from "../../@types/Booking/companyDetails";
import * as DateFns from "date-fns";
import { MacroClassGroup } from "../../@types/DTO/MacroClass";
import i18n from "../../config/i18n";
import { NexiChargeTransactionDetails } from "../../@types/Booking/nexiTransactionDetails";
import { StripeTransactionDetails } from "../../@types/Booking/stripeTransactionDetails";
import bcrypt from "bcryptjs";
import CryptoJS from "crypto-js";

class BookingApi {
  allReservationSources: BookingSourceResponse[] = [];
  MacroClassList: MacroClassGroup[] = [];
  public bookingApiRequestInstance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL_2,
  });

  private token_value = "mercedes_dogma_23031508$_mbrent_@#99907$$";

  private encryptToken = (token) => {
    return CryptoJS.AES.encrypt(
      token,
      process.env.REACT_APP_SECRET_KEY
    ).toString();
  };

  getBookingDetailsByVoucherCode(
    reservationVoucher: string,
    firstName: string,
    lastName: string,
    companyName: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<CreateNewBooking>(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/by/voucher`,
      {
        reservationVoucher: reservationVoucher,
        customerFirstName: firstName,
        customerLastName: lastName,
        companyName: companyName,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  getReservationVehicles(bookingDetails: BookingDetails, dealerId) {
    if (
      !bookingDetails?.pickUpDateAndTime ||
      !bookingDetails?.dropOffDateAndTime == null
    ) {
      return Promise.reject("Dates not found");
    }
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/touroperator/quotations?idSupplier=${dealerId}`,
      {
        endDate:
          DateFns.format(bookingDetails.dropOffDateAndTime, "yyyy-MM-dd") +
          "T" +
          DateFns.format(bookingDetails.dropOffDateAndTime, "HH:mm:ss"),
        startDate:
          DateFns.format(bookingDetails.pickUpDateAndTime, "yyyy-MM-dd") +
          "T" +
          DateFns.format(bookingDetails.pickUpDateAndTime, "HH:mm:ss"),
        age: 25,
        isYoungDriverAge: "false",
        isYoungDriver2Age: "false",
        isSeniorDriverAge: "false",
        noFeeAge: "false",
        pickUpLocation: bookingDetails.pickUpLocationDetails.code,
        dropOffLocation: bookingDetails.dropOffLocationDetails.code,
        showPics: bookingDetails.showPics,
        showOptionalImage: bookingDetails.showOptionalImage,
        showVehicleParameter: bookingDetails.showVehicleParameter,
        showVehicleExtraImage: bookingDetails.showVehicleExtraImage,
        showBookingDiscount: bookingDetails.showBookingDiscount,
        agreementCoupon: bookingDetails?.agreementCoupon || null,
        macroGroupName: bookingDetails?.macroGroupName || null,
        bookingChannel:
          bookingDetails.reservationSource != null
            ? bookingDetails.reservationSource
            : "WEB001",
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }
  getBookingDetailsByBookingDateAndReservationCode(
    reservationPrefix: string,
    reservationNumber: string,
    reservationDate: Date
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<CreateNewBooking>(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/by/number`,
      {
        reservationDate:
          DateFns.format(reservationDate, "yyyy-MM-dd") +
          "T" +
          DateFns.format(reservationDate, "HH:mm:ss"),
        reservationPrefix,
        reservationNumber: parseInt(reservationNumber),
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }
  registerNewUser(e) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<CreateNewBooking>(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/register`,
      {
        firstName: e.firstName,
        middleName: e.middleName,
        lastName: e.lastName,
        companyName: e.companyName,
        mobileNumber: e.mobileNumber,
        email: e.email,
        country: e.country,
        state: e.state,
        city: e.city,
        streetName: e.streetName,
        streetNumber: e.streetNumber,
        Zip: e.zip,
        vatNumber: e.vatNumber,
        ssnNumber: e.ssnNumber,
        sex: e.sex,
        telephone: e.telephone,
        birthDate: e.birthDate,
        birthPlace: e.birthPlace,
        birthProvidence: e.birthProvince,
        birthNation: e.birthNation,
        isDriver: e.isDriver,
        licence: e.license,
        issuedBy: e.issuedBy,
        licenceType: e.licenseType,
        documentIssueDate: e.documentIssueDate,
        documentExpiryDate: e.documentExpiryDate,
        documentNumber: e.documentNumber,
        document: e.document,
        customerId: e.customerId,
        customerType: e.customerType,
        password: e.password,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }
  onlineUserAuthentication(
    email: string,
    password: string
  ): Promise<AxiosResponse<UserLoginResponse>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<UserLoginResponse>(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/login`,
      {
        email,
        password,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  addDrivers(
    reservationId: number,
    driverDetails: [DetailsFormValues, DetailsFormValues, DetailsFormValues]
  ): Promise<AxiosResponse<CustomerDetailsResponse_2>[]> {
    const hashedToken = this.encryptToken(this.token_value);

    const driverDetails_filtered = driverDetails
      .map((e) => {
        if (!e) {
          return;
        }
        const temp = e;
        for (const i of Object.keys(temp)) {
          if (!temp[i]) {
            delete temp[i];
          }
        }
        return {
          ...temp,
          zip: parseInt(e.zip || ""),
          isDriver: e.isDriver.toLowerCase() == "yes",
          customerType: e.customerType.toUpperCase(),
        };
      })
      .filter((e) => {
        return !!e;
      });
    return (
      axios
        .post(
          process.env.REACT_APP_SERVER_URL_2 +
            "/driver/add/reservation/" +
            reservationId,
          {
            driverDetails: driverDetails_filtered,
          },
          {
            headers: {
              Authorization: `Bearer ${hashedToken}`,
              "Cache-Control": "no-store, no-cache, must-revalidate",
              Pragma: "no-cache",
              Expires: "0",
            },
            withCredentials: true,
          }
        )
        // chaining an api call to upload documents
        .then((e) => {
          e.data.map((e: CustomerDetailsResponse_2, index) => {
            // iterate through api response containing driver details
            if (driverDetails_filtered[index]?.documents.length) {
              // skip if not uploaded documents
              this.bookingApiRequestInstance.post(
                process.env.REACT_APP_SERVER_URL_2 +
                  "/driver/upload-documents/" +
                  e.customerId,
                driverDetails_filtered[index]?.documents.reduce(
                  // reduce to a form data with array of files in files key
                  (prev, current) => {
                    prev.append("files", current); // appending file in files key
                    return prev;
                  },
                  new FormData() // form data object
                )
              );
            }
          });
          return e.data;
        })
    );
  }

  async addDocuments(
    customerId: number,
    documents: Array<File>
  ): Promise<AxiosResponse<DocumentUploadResponse>> {
    const hashedToken = this.encryptToken(this.token_value);
    const formData = new FormData();
    formData.append("files", "");
    documents.map((el) => formData.append("files", el));
    return this.bookingApiRequestInstance.put<DocumentUploadResponse>(
      process.env.REACT_APP_SERVER_URL_2 + "/documents/" + customerId,
      formData,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  async getCustomerDetails(
    customerId: number
  ): Promise<AxiosResponse<CustomerDetailsResponse_2>> {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .get<CustomerDetailsResponse_2>(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        e.data.documents = [];
        return e;
      });
  }

  async updateCustomerDetails(
    customerId: number,
    customerDetails: DetailsFormValues
  ): Promise<AxiosResponse<CustomerDetailsResponse>> {
    const hashedToken = this.encryptToken(this.token_value);
    const temp = formatUserDetails(customerDetails);
    return this.bookingApiRequestInstance.put<CustomerDetailsResponse>(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/${customerId}`,
      {
        ...temp,
        zip: parseInt(customerDetails.zip || ""),
        isDriver: customerDetails.isDriver?.toLowerCase() == "yes",
        customerType: customerDetails.customerType.toUpperCase(),
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  async getCity(cityName): Promise<AxiosResponse<StateResponse>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get<StateResponse>(
      `${process.env.REACT_APP_SERVER_URL_2}/locations/city/${cityName}/state_and_zip/all`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }
  async getStates(countryName = ""): Promise<AxiosResponse<string[]>> {
    const hashedToken = this.encryptToken(this.token_value);
    if (countryName != "") {
      return this.bookingApiRequestInstance.get<string[]>(
        `${process.env.REACT_APP_SERVER_URL_2}/locations/country/${countryName}/cities/all`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      );
    } else {
      const emptyCity: string[] = [];
      const emptyResponse: AxiosResponse<string[]> = {
        data: emptyCity,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        file: null,
      };
      return Promise.resolve(emptyResponse);
    }
  }

  async getReservationLocations(): Promise<AxiosResponse<Location[]>> {
    const hashedToken = this.encryptToken(this.token_value);
    const idSupplier: any = localStorage.getItem("idSupplier");
    const dealerID =
      idSupplier === undefined ||
      idSupplier === null ||
      idSupplier == "undefined"
        ? "null"
        : idSupplier;
    return this.bookingApiRequestInstance.get<Location[]>(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/locations/all/?idSupplier=${dealerID}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  async getAllCountries(): Promise<AxiosResponse<string[]>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get<string[]>(
      `${process.env.REACT_APP_SERVER_URL_2}/locations/country/all`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  async getItalianCustomerDetailsBySSN(
    ssn: string
  ): Promise<AxiosResponse<ItalianCustomerDetailsUsingSSNResponse>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get<ItalianCustomerDetailsUsingSSNResponse>(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/details/by/ssn/${ssn}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }
  async getSsnByCustomerDetails(
    firstName: string,
    lastName: string,
    birthNation: string,
    birthPlace: string,
    sex: string,
    dob: Date,
    country: string
  ): Promise<AxiosResponse<SsnByItalianCustomerDetails>> {
    const currentTime = new Date();
    const dobDatePart = new Date(dob);
    dobDatePart.setHours(currentTime.getHours());
    dobDatePart.setMinutes(currentTime.getMinutes());
    dobDatePart.setSeconds(currentTime.getSeconds());
    dobDatePart.setMilliseconds(currentTime.getMilliseconds());
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<SsnByItalianCustomerDetails>(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/details_by_ssn`,
      {
        firstName,
        lastName,
        birthNation: birthNation,
        birthPlace: birthPlace,
        sex: sex.toUpperCase(),
        dob: new Date(dobDatePart).toISOString(),
        national: country,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  async getPrivacyPolicy(
    reservationId?: number | null,
    callFrom?: string
  ): Promise<AxiosResponse<PrivacyPolicy>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get<PrivacyPolicy>(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/privacy-policy/${reservationId}/${callFrom}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  async savePrivacyPolicy(
    reservationId: number,
    acceptedPolicies: number[]
  ): Promise<AxiosResponse<PrivacyPolicy>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<PrivacyPolicy>(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/privacy-policy/${reservationId}`,
      {
        acceptedPrivacyPolicies: acceptedPolicies,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  async createBooking(
    reservationInfo: BookingDetails,
    vehicleInfo: Vehicle,
    paymentInfo: SelectedVehicleDetails,
    paymentMethod: string,
    userId: string | undefined,
    attachedCustomer: string | undefined,
    attachedDriver: string | undefined,
    driver2: string | undefined,
    driver3: string | undefined,
    idSupplier: string
  ): Promise<AxiosResponse<ReservationSuccessfullResponse> | string> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<ReservationSuccessfullResponse>(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/touroperator/bookingForMercedes?idSupplier=${idSupplier}`,
      {
        isDiscounted: paymentInfo.isDiscounted,
        isPayLaterFee: paymentInfo.isPayLaterFee,
        payLaterFeeAmt: paymentInfo.payLaterFeeAmt,
        agreementCoupon: reservationInfo.agreementCoupon,
        discountValueWithoutVat: vehicleInfo?.Reference?.ID?.toString(),
        reservationInfo: {
          endDate:
            DateFns.format(reservationInfo.dropOffDateAndTime, "yyyy-MM-dd") +
            "T" +
            DateFns.format(reservationInfo.dropOffDateAndTime, "HH:mm:ss"),
          startDate:
            DateFns.format(reservationInfo.pickUpDateAndTime, "yyyy-MM-dd") +
            "T" +
            DateFns.format(reservationInfo.pickUpDateAndTime, "HH:mm:ss"),
          pickUpLocation: reservationInfo.pickUpLocationDetails.code,
          dropOffLocation: reservationInfo.dropOffLocationDetails.code,
          bookingChannel: reservationInfo.reservationSource.code,
        },
        vehicleInfo: {
          VehicleCode: vehicleInfo?.Vehicle?.Code,
        },
        paymentMethod: paymentMethod,
        insuranceId: paymentInfo?.selectedInsurance?.insuranceId?.toString(),
        Fee: {
          Amount: paymentInfo?.price?.toString(),
          CurrencyCode: "EUR",
        },
        isEndUserBooking: "true",
        onlineUser: { id: userId },
        attachedDriver: attachedDriver || attachedCustomer,
        attachedCustomer: attachedCustomer,
        driver2: driver2,
        driver3: driver3,
        bookingLang: i18n.language,
        optionals: Object.values(paymentInfo?.addedExtraOptions).map((e) => {
          return {
            Equiptype: e.name,
            Quantity: e.quantity.toString(),
            price: parseInt(e.price.toString()),
          };
        }),
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  async validateSSNField(customerInfo: DetailsFormValues) {
    const currentTime = new Date();
    const dobDatePart = new Date(customerInfo?.dateOfBirth);
    dobDatePart.setHours(currentTime.getHours());
    dobDatePart.setMinutes(currentTime.getMinutes());
    dobDatePart.setSeconds(currentTime.getSeconds());
    dobDatePart.setMilliseconds(currentTime.getMilliseconds());
    const hashedToken = this.encryptToken(this.token_value);
    if (customerInfo.country?.toLowerCase().includes("ital")) {
      return await this.bookingApiRequestInstance
        .post<SsnByItalianCustomerDetails>(
          `${process.env.REACT_APP_SERVER_URL_2}/customer/details_by_ssn`,
          {
            firstName: customerInfo.firstName,
            lastName: customerInfo.lastName,
            birthNation: customerInfo.birthNation,
            birthPlace: customerInfo.birthPlace,
            sex: customerInfo.sex ? customerInfo.sex.toUpperCase() : "",
            dob: customerInfo.dateOfBirth
              ? new Date(dobDatePart).toISOString()
              : "",
            national: customerInfo.country,
          },
          {
            headers: {
              Authorization: `Bearer ${hashedToken}`,
              "Cache-Control": "no-store, no-cache, must-revalidate",
              Pragma: "no-cache",
              Expires: "0",
            },
            withCredentials: true,
          }
        )
        .then((e) => {
          const data = e.data || "";
          if (
            data.toString().toLowerCase() !==
            customerInfo?.ssnNumber?.toLowerCase()
          ) {
            return "Invalid TaxCode";
          } else {
            return "true";
          }
        });
    } else {
      return "true";
    }
  }

  async validateSSNFieldForCompany(companyInfo: companyDetails, ssn) {
    const currentTime = new Date();
    const dobDatePart = new Date(companyInfo.birthDate);
    dobDatePart.setHours(currentTime.getHours());
    dobDatePart.setMinutes(currentTime.getMinutes());
    dobDatePart.setSeconds(currentTime.getSeconds());
    dobDatePart.setMilliseconds(currentTime.getMilliseconds());
    const hashedToken = this.encryptToken(this.token_value);
    if (companyInfo.country?.toLowerCase().includes("ital")) {
      return await this.bookingApiRequestInstance
        .post<SsnByItalianCustomerDetails>(
          `${process.env.REACT_APP_SERVER_URL_2}/customer/details_by_ssn`,
          {
            firstName: companyInfo.firstName,
            lastName: companyInfo.lastName,
            birthNation: companyInfo.birthNation,
            birthPlace: companyInfo.birthPlace,
            sex: companyInfo.gender ? companyInfo.gender.toUpperCase() : "",
            dob: companyInfo.birthDate
              ? new Date(dobDatePart).toISOString()
              : "",
            national: companyInfo.country,
          },
          {
            headers: {
              Authorization: `Bearer ${hashedToken}`,
              "Cache-Control": "no-store, no-cache, must-revalidate",
              Pragma: "no-cache",
              Expires: "0",
            },
            withCredentials: true,
          }
        )
        .then((e) => {
          const data = e.data || "";
          if (data.toString() !== ssn) {
            return "Invalid CompanyTaxCode";
          } else {
            return "true";
          }
        });
    } else {
      return "true";
    }
  }

  async validateVATNumber(CompanyInfo: companyDetails) {
    const hashedToken = this.encryptToken(this.token_value);
    if (CompanyInfo.birthNation !== "ITALIA") {
      return true;
    } else {
      return await this.bookingApiRequestInstance
        .post<SsnByItalianCustomerDetails>(
          `${process.env.REACT_APP_SERVER_URL_2}/customer/validateVatApi`,
          {
            vatNumber: CompanyInfo.CompanyVatNumber,
            country: CompanyInfo.country,
          },
          {
            headers: {
              Authorization: `Bearer ${hashedToken}`,
              "Cache-Control": "no-store, no-cache, must-revalidate",
              Pragma: "no-cache",
              Expires: "0",
            },
            withCredentials: true,
          }
        )
        .then((e) => {
          const data = e.data || "";
          if (data.toString() === "true") {
            return true;
          } else {
            return false;
          }
        });
    }
  }

  getPaymentLink(reservationId: number, amount: number, paymentMode: string) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .post<PaymentLinkResponse>(
        `${process.env.REACT_APP_SERVER_URL_2}/settings/paymentLink/${reservationId}/${amount}`,
        {
          paymentMode,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }

  getAppSetting() {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .get<AppSettingResponse>(
        `${process.env.REACT_APP_SERVER_URL_2}/settings/app`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  createNewUser(e, dealerID) {
    const hashedToken = this.encryptToken(this.token_value);
    const hashedPassword = bcrypt.hashSync(e.password, 2);
    const idSupplier =
      dealerID === undefined || dealerID === null || dealerID == "undefined"
        ? "null"
        : dealerID;
    return axios
      .post(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/registerBookingUserForMercedes?idSupplier=${idSupplier}`,
        {
          firstName: e.firstName,
          lastName: e.lastName,
          phoneNumber: e.phoneNumber,
          email: e.email.toLowerCase(),
          password: e.password,
          onlineUserType: 3,
          onlineUserRole: 2,
          onlineUserStatus: 1,
          hashedPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then(function (response) {
        return response;
      });
  }
  loginUser(e, dealerId) {
    const hashedToken = this.encryptToken(this.token_value);
    const hashedPassword = bcrypt.hashSync(e.password, 2);
    const hashedEmail = this.encryptToken(e.email.toLowerCase());
    return axios
      .post(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/login?idSupplier=${dealerId}`,
        {
          email: hashedEmail,
          password: hashedPassword,
          callFrom: "mercedesBooking",
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then(function (response) {
        return response;
      });
  }

  logout() {
    const hashedToken = this.encryptToken(this.token_value);
    // Clear local storage
    localStorage.clear();

    // Clear session storage
    sessionStorage.clear();

    axios
      .get<AppSettingResponse>(
        `${process.env.REACT_APP_SERVER_URL_2}/settings/customerLogout`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((response) => {
        // console.log(response.data);
      });
  }

  getBookingDetailsbyUserId(userid: number, offset: number, max: number) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/bookinglist/by/userid/${userid}/reservationForMercedes/${offset}/${max}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  getRentalDetailsbyUserId(userId: number) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/getRentalsForOnlineUser/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  getLastBookingDetail(userId: number) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/getLastBookingDetails/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  getOnlineUserInvoices(userId: number, offset: number, max: number) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/getInvoiceListForOnlineUser/${userId}/${offset}/${max}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  downloadInvoice(invoiceId: number, idSupplier: String) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/downloadInvoice/${invoiceId}?idSupplier=${idSupplier}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  UpdateUserProfileById(id, e) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/onlineUser/updateOnlineUser/${id}`,
      {
        firstName: e.firstName,
        lastName: e.lastName,
        phoneNumber: e.phoneNumber,
        userImage: e.userImage,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  async getUserProfileByUserId(userid: number) {
    const hashedToken = this.encryptToken(this.token_value);
    try {
      const response = await this.bookingApiRequestInstance.get(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/getUserProfile/${userid}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      );
      return response;
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        return "Unauthorized access";
      } else {
        console.error("An unexpected error occurred:", error.message);
      }
      throw error;
    }
  }

  async getCustomerDeatilsByUserid(
    userid: number,
    offset: number,
    max: number
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return await this.bookingApiRequestInstance.get(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/onlineUser/${userid}/customer/${offset}/${max}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }
  async updateCustomerDetailByCustomerId(id, cid, data) {
    const hashedToken = this.encryptToken(this.token_value);
    return await axios
      .put(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/${id}/${cid}`,
        {
          firstName: data.firstName,
          middleName: data.middleName,
          lastName: data.lastName,
          companyName: data.companyName,
          mobileNumber: data.mobileNumber,
          email: data.email,
          country: data.country,
          state: data.state,
          city: data.city,
          streetName: data.street,
          streetNumber: data.streetNumber,
          zip: data.zip,
          vatNumber: data.vatNumber,
          ssnNumber: data.ssnNumber,
          sex: data.sex,
          telephone: data.telephone,
          dateOfBirth: data.dateofBirth,
          birthPlace: data.birthPlace,
          birthProvince: data.birthProvidence,
          birthNation: data.birthNation,
          isDriver: data.isDriver,
          license: data.licence,
          issuedBy: data.issuedBy,
          releaseDate: data.releaseDate,
          licenseType: data.licenceType,
          documentIssueDate: data.documentIssueDate,
          documentExpiryDate: data.documentExpiryDate,
          documentNumber: data.documentNumber,
          document: data.document,
          customerId: data.customerId,
          customerType: data.customerType,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e;
      });
  }

  async sentVerificationcode(e) {
    const hashedToken = this.encryptToken(this.token_value);
    // const id: any = localStorage.getItem("onlineUserId");
    const hashedEmail = this.encryptToken(e);
    return await axios
      .post(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/login/sendVerification`,
        {
          email: hashedEmail,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      })
      .catch((err) => {
        return err;
      });
  }

  async forgotPassword(otp, onlineUserId) {
    const hashedToken = this.encryptToken(this.token_value);
    const hashedEmail = this.encryptToken(otp.email);
    const hashedPassword = this.encryptToken(otp.newPassword);
    return await axios
      .post(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/login/verifyOtpChangePassword?onlineUserId=${onlineUserId}`,
        {
          verificationCode: otp.verificationCode,
          emailId: hashedEmail,
          newPassword: hashedPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      })
      .catch((err) => {
        return err;
      });
  }

  async changePassword(data) {
    const id: any = localStorage.getItem("userID");
    const idSupplier: any = localStorage.getItem("idSupplier");
    const hashedToken = this.encryptToken(this.token_value);
    const hashedNewPassword = await this.encryptToken(data.newPassword);
    const hashedConfirmPassword = await this.encryptToken(data.confirmPassword);
    const hashedOldPassword = await this.encryptToken(data.oldPassword);

    return await axios
      .post(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/changePasswordForOnlineUser/${id}?idSupplier=${idSupplier}`,
        {
          oldPassword: hashedOldPassword,
          newPassword: hashedNewPassword,
          confirmPassword: hashedConfirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      })
      .catch((err) => {
        return err;
      });
  }

  getInsuranceDetails(
    reservationDetails: BookingDetails,
    vehicleGroup: string,
    allVehicleAllOptions: OptionInVehicle[],
    idSupplier: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .post<InsuranceDetails>(
        `${process.env.REACT_APP_SERVER_URL_2}/reservations/touroperator/getInsuranceList?idSupplier=${idSupplier}`,
        {
          startDate: reservationDetails.pickUpDateAndTime,
          endDate: reservationDetails.dropOffDateAndTime,
          reservationSource:
            reservationDetails.reservationSource.code || "WEB001",
          group: vehicleGroup,
          locationCode: reservationDetails.pickUpLocationDetails.code,
          extras: allVehicleAllOptions?.map((e) => {
            return {
              code: e.Equipment.EquipType,
              amount: e.Charge.Amount,
            };
          }),
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        e.data["Booking Insurance"] = e.data["Booking Insurance"].sort(
          (o1, o2) => {
            return o1.Amount - o2.Amount;
          }
        );
        return e.data;
      });
  }
  sendEmailForWireTransfer(id: number, onRequest: string) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/touroperator/${id}/sendEmail`,
      {
        onRequest: onRequest,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  savePaymentForNexi(paymentDetails: NexiChargeTransactionDetails) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/handlePayments`,
      {
        ...paymentDetails,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  savePaymentForStripe(paymentDetails: StripeTransactionDetails) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/handlePayments1`,
      {
        ...paymentDetails,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  getPrivacyAndTerms(idSupplier: string) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .get<PrivacyTerms>(
        `${process.env.REACT_APP_SERVER_URL_2}/reservations/touroperator/getPrivacyAndTerms/${i18n.language}?idSupplier=${idSupplier}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }
  createNewOnlineUserAndCustomer(idSupplier: string) {
    const hashedToken = this.encryptToken(this.token_value);
    const userID: any = localStorage.getItem("userID");
    return axios
      .get<attachCustomer>(
        `${process.env.REACT_APP_SERVER_URL_2}/reservations/touroperator/createNewOnlineUserAndCustomer?idSupplier=${idSupplier}&userID=${userID}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }

  getAttachCust(idSupplier: string) {
    const hashedToken = this.encryptToken(this.token_value);
    const userID: any = localStorage.getItem("userID");
    return axios
      .get<attachCustomer>(
        `${process.env.REACT_APP_SERVER_URL_2}/reservations/touroperator/getAttachCust?idSupplier=${idSupplier}&userID=${userID}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }

  async getTextResource() {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.get<AxiosResponse>(
      `${process.env.REACT_APP_SERVER_URL_2}/settings/getTextResource/${i18n.language}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  cancelBooking(
    prefix: string,
    number: string,
    codice: string,
    cancelReason: string,
    reservationSourceCode: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/cancelBooking`,
      {
        prefix: prefix.toString(),
        number: number.toString(),
        codice: codice.toString(),
        cancelReason: cancelReason.toString(),
        channel: reservationSourceCode.toString(),
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  sendRequest(
    reservationId: string,
    name: string,
    description: string,
    contactNumber: string,
    email: string,
    bookingCancelReason: string,
    onlineUser: string | undefined,
    idSupplier: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      `${process.env.REACT_APP_SERVER_URL_2}/reservations/sendRequest?idSupplier=${idSupplier}`,
      {
        reservationId: reservationId?.toString(),
        name: name?.toString(),
        description: description?.toString(),
        contactNumber: contactNumber?.toString(),
        email: email ? email?.toString() : "null",
        bookingCancelReason: bookingCancelReason?.toString(),
        onlineUser: onlineUser?.toString(),
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  getReservationSourceForOnlineUser(userId: number) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/getReservationSourceForOnlineUser/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-store, no-cache, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        withCredentials: true,
      }
    );
  }

  getAllPaymentMethods(idSupplier: string) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .get<AllPaymentMethodsResponse>(
        `${process.env.REACT_APP_SERVER_URL_2}/settings/payments?idSupplier=${idSupplier}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }

  async createOnlineuserCustomer(data, userType, dealerId, userEntityType) {
    const hashedToken = this.encryptToken(this.token_value);
    const userID: any = localStorage.getItem("userID");
    let date, year, month, day, formattedDate;
    if (data.birthDate) {
      date = new Date(data.birthDate);
      year = date.getFullYear();
      month = String(date.getMonth() + 1).padStart(2, "0");
      day = String(date.getDate()).padStart(2, "0");
      formattedDate = `${year}-${month}-${day}`;
    } else if (data.dateOfBirth) {
      date = new Date(data.dateOfBirth);
      year = date.getFullYear();
      month = String(date.getMonth() + 1).padStart(2, "0");
      day = String(date.getDate()).padStart(2, "0");
      formattedDate = `${year}-${month}-${day}`;
    }
    let formattedReleaseDate, formattedExpiryDate;
    if (data.releaseDate) {
      date = new Date(data.releaseDate);
      year = date.getFullYear();
      month = String(date.getMonth() + 1).padStart(2, "0");
      day = String(date.getDate()).padStart(2, "0");
      formattedReleaseDate = `${year}-${month}-${day}`;
    }
    if (data.documentExpiryDate) {
      date = new Date(data.documentExpiryDate);
      year = date.getFullYear();
      month = String(date.getMonth() + 1).padStart(2, "0");
      day = String(date.getDate()).padStart(2, "0");
      formattedExpiryDate = `${year}-${month}-${day}`;
    }
    const gender =
      data.gender === "MASCHIO" ||
      data.gender === "MALE" ||
      data.sex === "MASCHIO" ||
      data.sex === "MALE"
        ? "MALE"
        : data.gender === "FEMMINA" ||
          data.gender === "FEMALE" ||
          data.sex === "FEMMINA" ||
          data.sex === "FEMALE"
        ? "FEMALE"
        : "N/A";

    return await axios
      .post(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/createOnlineuserCustomer/${userID}?idSupplier=${dealerId}`,
        {
          isPhysicalPerson: localStorage.getItem("isPhysicalPerson"),
          onlineUserID: userID,
          birthNation: data.birthNation,
          birthPlace: data.birthPlace,
          birthProv: data.birthProvince || data.CompanyBirthProv,
          gender: gender,
          birthDate: formattedDate,
          taxCode:
            data.ssnNumber ||
            (
              document.getElementsByName(
                "CompanySSNNumber"
              )[0] as HTMLInputElement
            )?.value,
          isIndividualCompany: userType == "Individual",
          companyName: data.CompanyName,
          street: data.streetName || data.CompanyStreet,
          number: data.streetNumber || data.CompanyStreetNumber,
          postalCode: data.zip || data.CompanyPostalCode,
          national: data.national,
          province: data.province,
          city: data.city,
          country: data.country,
          state: data.state,
          isClient: userType != "driver",
          isDriver: userEntityType != "legalentity" ? true : false,
          userType: userType == "driver" ? "enduser" : userType,
          lastName:
            userType == "enduser"
              ? localStorage.getItem("onlineuserFName")
              : data.lastName,
          firstName:
            userType == "enduser"
              ? localStorage.getItem("onlineuserLName")
              : data.firstName,
          mobileNumber:
            data.telephone ||
            data.CompanyPhoneNumber ||
            localStorage.getItem("mobileNumber"),
          email:
            userType == "enduser"
              ? localStorage.getItem("onlineuserEmailId")
              : data.CompanyEmail || data.email,
          eInvoiceEmail: data.CompanyEInvoicingEmail,
          eInvoiceCode: data.CompanyEInvoicingCode,
          document: data.document,
          documentNumber: data.documentNumber,
          expiryDate: formattedExpiryDate,
          licenseType: data.licenseType,
          issuedBy: data.issuedBy,
          releaseDate: formattedReleaseDate,
          entityType: userEntityType,
          vatNumber: data.vatNumber || data.CompanyVatNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-store, no-cache, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      })
      .catch((err) => {
        return err;
      });
  }
}

function formatUserDetails(
  customerInfo: DetailsFormValues
): Record<string, any> {
  return Object.entries(customerInfo).reduce((acc, [key, value]) => {
    if (value === "") return acc;

    if (key === "zip") {
      acc[key] = parseInt(value.toString(), 10);
    } else if (key === "ssnNumber") {
      acc[key] = value.toString();
    } else {
      acc[key] = value;
    }

    return acc;
  }, {} as Record<string, any>);
}

const BookingApiInstance: BookingApi = new BookingApi();
export { BookingApiInstance as default, BookingApiInstance as BookingApi };
